export default function StoreCards({ stores, onSelect }) {
  const getStoreColor = (store) => {
    // Solo en MP (no registrada en BD) → ámbar
    if (!store.in_db) return 'border-amber-500/60 bg-amber-900/10 hover:border-amber-400';
    // En BD pero sin sync con MP → amarillo
    if (!store.in_mp) return 'border-yellow-600/40 bg-yellow-900/5 hover:border-yellow-400';
    // Sucursal sincronizada (in_db && in_mp) → verde fuerte
    // El estado granular de POS/terminales se muestra vía emoji, no en el color de tarjeta
    return 'border-emerald-500 bg-emerald-900/15 hover:border-emerald-400';
  };

  const getStatusEmoji = (store) => {
    if (!store.in_db) return '⚠';
    const allPos = store.pos || [];
    if (allPos.some(p => p.terminal?.mp_status === 'disabled')) return '🔴';
    if (allPos.some(p => !p.terminal || p.terminal?.operating_mode === 'STANDALONE')) return '🟡';
    return '🟢';
  };

  if (!stores.length) {
    return <div className="card text-center py-8 text-slate-500 text-sm">No hay sucursales registradas</div>;
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
      {stores.map((store) => (
        <button
          key={store.external_id}
          onClick={() => onSelect(store)}
          className={`text-left p-4 rounded-xl border-2 transition-all ${getStoreColor(store)}`}
        >
          <div className="flex items-start justify-between gap-2 mb-2">
            <div className="min-w-0">
              <p className="font-semibold text-slate-100 text-sm leading-tight truncate">{store.name}</p>
              <p className="font-mono text-xs text-slate-500 mt-0.5">{store.external_id}</p>
            </div>
            <span className="text-xl shrink-0">{getStatusEmoji(store)}</span>
          </div>
          {store.city_name && <p className="text-xs text-slate-500">{store.city_name}</p>}
          <div className="mt-2 flex items-center gap-1.5 flex-wrap">
            <span className="text-xs text-slate-400">{store.pos?.length || 0} POS</span>
            {!store.in_db && (
              <span className="text-xs px-1.5 py-0.5 rounded bg-amber-900/40 text-amber-300 border border-amber-700/40">Solo en MP</span>
            )}
          </div>
          <p className="text-xs text-accent/70 mt-2">Ver nodos →</p>
        </button>
      ))}
    </div>
  );
}
